import React, { useState, useEffect, useContext, useCallback } from "react";
import { useParams } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import ButterflyLock from "../images/lockbutterfly-themeblk.png";
import { calculatePercentage, checkImageExist } from "../utils/helper";
import {
    FOLLOW_TIER,
    NUT_THEME_USERS,
    PAUSE_STATUS,
    POST_STATUS,
    s3Link,
} from "../utils/constants";
import moment from "moment";
import PostsContent from "./Post/posts-contents";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import MediaContents from "./Post/media-contents";
import PThankYou from "./PThankYou";
import { FOLLOW_STATUS, ROLES } from "../utils/constants";
import { Helmet } from "react-helmet";
import Avatar from "./Avatar";
import { connect, useDispatch } from "react-redux";
import Subcovers from "./Profile/Subcovers";
import { getSubcovers } from "../../redux/actions/user";
import { isMobile } from "react-device-detect";
import ProfileContainer from "./Profile/ProfileContainer";
import { ProfileContext } from "./Profile/ProfileContext";
import ShopContents from "./Post/shop-contents";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Badge, useMediaQuery } from "@mui/material";
import DefaultWidget from "../Widgets/SU/Default";
import DefaultPUWidget from "../Widgets/PU/Default";
import PSignupModal from "./PSignupModal";
import { styled } from "@mui/material/styles";

function tabProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            className="full-width-tabpanel"
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

let isNutTheme = false;
const StyledTabs = styled((props) => (
    <Tabs
        {...props}
        TabIndicatorProps={{
            children: <span className="MuiTabs-indicatorSpan" />,
        }}
    />
))(({ theme }) => ({
    "& .MuiTabs-indicator": {
        backgroundColor: isNutTheme ? "#ffd700" : "#0097fe",
    },
    "& .MuiTabs-indicatorSpan": {
        backgroundColor: isNutTheme ? "#ffd700" : "#0097fe",
    },
}));

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
    ({ theme, props }) => ({
        textTransform: "none",
        fontWeight: theme.typography.fontWeightRegular,
        "&.Mui-selected": {
            color: isNutTheme ? "#ffd700" : "#0097fe",
        },
    })
);

// user is from params, profile component
const ProfileView = ({
    user,
    getUserInformation = () => ({}),
    isProcessing,
    subcovers,
    isDarkmode,
}) => {
    const params = useParams();
    const dispatch = useDispatch();

    const { processingIntent, intentCompleted } = useContext(ProfileContext);

    const [link, setLink] = useState("");
    const [show, setShow] = useState(false);
    const [post, setPost] = useState({});
    const [signupFormStatus, setSignupFormStatus] = useState(false);
    const [conversation, setConversation] = useState("");
    const [key, setKey] = useState(0);
    const [followStatus, setFollowStatus] = useState(false);

    const [thankYou, setThankYou] = useState(false);
    const [tipSuccess, setTipSuccess] = useState(false);
    const [conversationIsLoading, setConversationIsLoading] = useState(false);

    const type = localStorage.getItem("loggedin_user") ? "follow" : "signup";
    const [coverPic, setCoverPic] = useState("");
    const [promoUrl, setPromoUrl] = useState({});
    const [savings, setSavings] = useState("");
    const [mobile, setMobile] = useState(false);

    const handleChangeTab = (event, newValue) => {
        const containerHeight = document
            .getElementById("pu-content-container")
            .getBoundingClientRect().offsetHeight;
        $("#pu-content-container").height(containerHeight);

        setKey(newValue);
    };

    const userInformation = JSON.parse(localStorage.getItem("user"));

    useEffect(() => {
        setMobile(isMobile);
    }, []);

    useEffect(() => {
        overRideImages();
    }, [user, mobile]);

    useEffect(() => {
        if (isThemeblk()) {
            isNutTheme = true;
        } else {
            isNutTheme = false;
        }

        return () => {
            if ($("body").hasClass("themeblk")) {
                $("body").removeClass("themeblk");

                if (isDarkmode && $("body").hasClass("lightmode")) {
                    $("body").removeClass("lightmode");
                    $("body").addClass("darkmode");
                } else if ($("body").hasClass("darkmode")) {
                    $("body").removeClass("darkmode");
                    $("body").addClass("lightmode");
                }
            }
        };
    }, [user]);

    const overRideImages = () => {
        let image = "";

        //  override image
        if (isThemeblk() && user.creator.profile_bkg) {
            if (mobile) {
                image = `${s3Link}/${
                    user.id
                }/back_port.jpg?t=${new Date().valueOf()}`;
            } else {
                image = `${s3Link}/${
                    user.id
                }/back_land.jpg?t=${new Date().valueOf()}`;
            }
        } else {
            image = `${s3Link}/${
                user.id
            }/cover_photo.jpg?t=${new Date().valueOf()}`;
        }

        setCoverPic(image);
    };

    useEffect(() => {
        let mounted = true;

        if (isThemeblk()) {
            const payload = {
                pu_id: user.id,
            };
            dispatch(getSubcovers(payload));
        }

        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        if (followStatus) {
            getUserInformation();
            getConversation();
        }
    }, [followStatus]);

    useEffect(() => {
        if (tipSuccess) {
            setShowModal(false);
            setThankYou(true);
        }
    }, [tipSuccess]);

    useEffect(() => {
        if (signupFormStatus) {
            window.location = "/edit-profile";
        }
    }, [signupFormStatus]);

    const getFirstPostDate = async () => {
        const url = userInformation ? `/api/posts` : "/api/unauth-posts";
        await axios
            .get(url, {
                params: {
                    user: params.username,
                    from: "unsubscribed",
                    status: POST_STATUS.PUBLISHED,
                },
            })
            .then((response) => {
                setPost(response.data);
            });
    };

    const getProfileTheme = () => {
        return NUT_THEME_USERS.includes(user.id) ? "themeblk-follow-btn" : "";
    };

    const getProfileThemeDisabled = () => {
        return NUT_THEME_USERS.includes(user.id)
            ? "themeblk-follow-disabled"
            : "disable-link disabled";
    };

    const setFollowBottonOnBanner = () => {
        return NUT_THEME_USERS.includes(user.id)
            ? "themeblk-follow-banner-btn"
            : "";
    };

    const setThemeBottomBanner = () => {
        // return 'themeblk-follow-banner';
        return NUT_THEME_USERS.includes(user.id)
            ? "themeblk-follow-banner"
            : "botm-ban";
    };

    const showButterflyLock = () => {
        return true; // show to all users
        // return NUT_THEME_USERS.includes(user.id);
    };

    const isThemeblk = () => {
        return NUT_THEME_USERS.includes(user.id);
    };

    const hasProfileBackground = () => {
        return user.creator && user.creator.profile_bkg;
    };

    const getConversation = () => {
        setConversationIsLoading(true);
        axios
            .get(`/api/conversations`, {
                params: {
                    to: params.username ? params.username : user.login,
                },
            })
            .then((response) => {
                setConversation(response.data);
            })
            .catch((error) => {
                console.log({ error });
            })
            .finally(() => {
                setConversationIsLoading(false);
            });
    };

    useEffect(() => {
        setLink(window.location.href);
        if (
            Object.keys(user).length > 0 &&
            [FOLLOW_STATUS.UNSUBSCRIBED, false].includes(
                user.subscription_status
            )
        ) {
            // getFirstPostDate();
        } else {
            if (userInformation && Object.keys(userInformation).length > 0) {
                getConversation();
            }
        }

        if (
            user.creator &&
            user.creator.promo_details &&
            parseFloat(user.creator.promo_details.promo_price) > 0
        ) {
            $(".main-app").addClass("has-promo");
        } else {
            $(".main-app").removeClass("has-promo");
        }
    }, []);

    useEffect(() => {
        if (
            Object.keys(user).length > 0 &&
            [FOLLOW_STATUS.UNSUBSCRIBED, false].includes(
                user.subscription_status
            )
        ) {
            getFirstPostDate();
        }
    }, [user]);

    const [showModal, setShowModal] = useState(false);
    const [showPPVModal, setShowPPVModal] = useState(false);

    useEffect(() => {
        if (promoUrl && Object.keys(promoUrl).length > 0) {
            let percent = calculatePercentage(
                promoUrl.link_price,
                user.creator.subscription_price
            );
            setSavings(percent.toFixed(2).replace(".00", ""));
        }
    }, [promoUrl]);

    const maxWords = 6;
    const [shortCaption, setShortCaption] = useState("");

    const RenderCaption = ({ caption }) => {
        const [showMore, setShowMore] = useState(false);

        useEffect(() => {
            if (caption && caption.split(" ").length > maxWords) {
                setShortCaption(truncate(caption, maxWords));
            }
        }, [caption]);

        const toggleShowCaption = (e) => {
            e.preventDefault();
            setShowMore((showMore) => !showMore);
        };

        const truncate = (str, no_words) => {
            const firstLine = str.split("\n");
            return firstLine[0].split(" ").splice(0, no_words).join(" ");
        };

        if (shortCaption && !showMore) {
            return (
                <React.Fragment>
                    <div
                        style={{ display: "inline", fontWeight: "normal" }}
                        dangerouslySetInnerHTML={{ __html: shortCaption }}
                    />
                    ...{" "}
                    <a href="#" onClick={toggleShowCaption}>
                        Read more
                    </a>
                </React.Fragment>
            );
        } else if (shortCaption && showMore) {
            return (
                <React.Fragment>
                    <div
                        style={{ display: "inline", fontWeight: "normal" }}
                        dangerouslySetInnerHTML={{ __html: caption }}
                    />{" "}
                    <a href="#" onClick={toggleShowCaption}>
                        Read less
                    </a>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <div
                        style={{ display: "inline" }}
                        dangerouslySetInnerHTML={{ __html: caption }}
                    />
                </React.Fragment>
            );
        }
    };

    const isMobile = useMediaQuery("(max-width: 899px)");
    const [containerMax, setContainerMax] = useState(0);
    const [currentWidth, setCurrentWidth] = useState(0);
    const [willExpand, setWillExpand] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const profileBioContainerRef = useCallback((node) => {
        if (node) {
            setContainerMax(node.offsetWidth);
        }
    });
    const bioContentRef = useCallback(
        (node) => {
            if (node) {
                if (currentWidth !== node.offsetWidth) {
                    if (node.offsetWidth + 50 >= containerMax) {
                        setCurrentWidth(node.offsetWidth - 50);
                        setWillExpand(true);
                    } else {
                        setCurrentWidth(node.offsetWidth);
                        setWillExpand(false);
                    }
                }
            }
        },
        [containerMax, currentWidth]
    );
    const onExpand = () => {
        setIsExpanded(!isExpanded);
    };
    useEffect(() => {
        const handleResize = () => {
            setContainerMax(containerMax);
            setCurrentWidth(containerMax);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleFollowClick = (e) => {
        e.preventDefault();
        window.dispatchEvent(new Event("follow-click"));
    };

    return (
        <div
            className={`pu-profile-page-content profile-page ${
                isThemeblk() ? "themeblk-content" : ""
            }`}
        >
            {(thankYou || intentCompleted) && (
                <PThankYou
                    show={thankYou || intentCompleted}
                    pu={user}
                    setShow={setThankYou}
                />
            )}

            {show && (
                <PSignupModal
                    showModal={show}
                    setShowModal={setShow}
                    user={user}
                    type={type}
                    setSignupFormStatus={setSignupFormStatus}
                    setFollowStatus={setFollowStatus}
                    getUserInformation={getUserInformation}
                />
            )}

            <Helmet>
                <title>
                    {user.login} | Best way to make money as an influencer for
                    your exclusive content
                </title>
                <meta
                    name="description"
                    content={
                        user.login +
                        " is on Best way to make money as an influencer for your exclusive content. Join Best way to make money as an influencer for your exclusive content to view Karen7's profile"
                    }
                />
                <meta name="keywords" content="Privaposts" />

                {/* LCP Fix */}
                {user.cover_pic && (
                    <link
                        rel="preload"
                        as="image"
                        href={coverPic}
                        type="image/jpeg"
                    />
                )}
            </Helmet>

            {!isThemeblk() ? (
                <Grid2
                    container
                    spacing={
                        !isMobile &&
                        userInformation &&
                        Object.keys(userInformation).length > 0
                            ? 2
                            : 0
                    }
                    justifyContent="center"
                >
                    <Grid2 md={8}>
                        <ProfileContainer
                            user={user}
                            coverPic={coverPic}
                            getUserInformation={getUserInformation}
                            subcovers={subcovers}
                        />

                        <div
                            className={`container profile__bio-container ${
                                isThemeblk()
                                    ? "themeblk-profile__bio-container"
                                    : ""
                            }`}
                        >
                            {[
                                FOLLOW_STATUS.ACTIVE,
                                FOLLOW_STATUS.UNFOLLOWED_DOES_NOT_RENEW,
                                FOLLOW_STATUS.PAUSED,
                            ].includes(user.subscription_status) && (
                                <div
                                    className={`container post-media-tabbed-container`}
                                >
                                    <StyledTabs
                                        value={key}
                                        onChange={handleChangeTab}
                                        indicatorColor="primary"
                                        textColor="primary"
                                        variant="fullWidth"
                                        aria-label="full width profile tabs"
                                        nutTheme={isThemeblk()}
                                    >
                                        <StyledTab
                                            className="profile-tab"
                                            label={
                                                <i className="fa-regular fa-photo-film"></i>
                                            }
                                            {...tabProps(0)}
                                            nutTheme={isThemeblk()}
                                        />

                                        <StyledTab
                                            className="profile-tab"
                                            label={
                                                <i className="fa-sharp fa-solid fa-grid"></i>
                                            }
                                            {...tabProps(1)}
                                            nutTheme={isThemeblk()}
                                        />

                                        <StyledTab
                                            className="profile-tab"
                                            label={
                                                <Badge
                                                    anchorOrigin={{
                                                        vertical: "top",
                                                        horizontal: "right",
                                                    }}
                                                    sx={{
                                                        "& .MuiBadge-badge": {
                                                            backgroundColor:
                                                                "transparent",
                                                            color: isThemeblk()
                                                                ? "#ffd700"
                                                                : "#0097fe",
                                                            fontWeight: "bold",
                                                            right: "-16px",
                                                        },
                                                    }}
                                                    badgeContent="NEW"
                                                >
                                                    <i className="fa-regular fa-cart-shopping"></i>
                                                </Badge>
                                            }
                                            {...tabProps(2)}
                                            nutTheme={isThemeblk()}
                                        />
                                    </StyledTabs>
                                    <div id="pu-content-container">
                                        <TabPanel value={key} index={0}>
                                            <PostsContent user={user} />
                                        </TabPanel>
                                        <TabPanel value={key} index={1}>
                                            <MediaContents user={user} />
                                        </TabPanel>
                                        <TabPanel value={key} index={2}>
                                            <ShopContents user={user} />
                                        </TabPanel>
                                    </div>
                                </div>
                            )}

                            {((!userInformation && user.role == ROLES.PU) ||
                                ([ROLES.PU, ROLES.ADMIN].includes(
                                    parseInt(user.role)
                                ) &&
                                    [
                                        FOLLOW_STATUS.UNSUBSCRIBED,
                                        false,
                                    ].includes(user.subscription_status))) && (
                                <div className="post-box post-box-follow banned-content-container">
                                    <div className="user-info clearfix">
                                        <div className="info-lft pull-left">
                                            <div className="usr-img img-div">
                                                <Avatar
                                                    pu={user}
                                                    story={false}
                                                />
                                            </div>
                                            <div className="user-name">
                                                <p>
                                                    <strong>
                                                        {user.firstname}{" "}
                                                        {user.lastname}
                                                    </strong>{" "}
                                                    <span>
                                                        <a
                                                            href={`${window.location.origin}/${user.login}`}
                                                        >
                                                            @{user.login}
                                                        </a>
                                                    </span>
                                                </p>
                                                <div className="mobile-time">
                                                    {post.created_at
                                                        ? moment
                                                              .utc(
                                                                  post.created_at
                                                              )
                                                              .local()
                                                              .format("lll")
                                                        : ""}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className={` ${setThemeBottomBanner()}`}
                                    >
                                        <div className="follow-prv-host-one ajaxconttest">
                                            {showButterflyLock() ? (
                                                <div
                                                    className={
                                                        "butterfly-locked"
                                                    }
                                                >
                                                    {" "}
                                                    <LazyLoadImage
                                                        src={ButterflyLock}
                                                        alt="ban-logo"
                                                    />{" "}
                                                </div>
                                            ) : (
                                                <></>
                                            )}
                                            <h3>
                                                <span>
                                                    Follow to see my private
                                                    posts
                                                </span>
                                            </h3>

                                            {![1, 30167].includes(user.id) ? (
                                                <a
                                                    onClick={handleFollowClick}
                                                    className={`btn btn-follow-2 btn-default ${setFollowBottonOnBanner()}  ${
                                                        isProcessing ||
                                                        processingIntent
                                                            ? " disable-link disabled"
                                                            : ""
                                                    }`}
                                                >
                                                    {isProcessing ||
                                                    processingIntent
                                                        ? "PROCESSING..."
                                                        : user.creator
                                                              .free_subscription
                                                        ? "FOLLOW FOR FREE"
                                                        : "SUBSCRIBE"}
                                                </a>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </Grid2>

                    {!isMobile &&
                    userInformation &&
                    Object.keys(userInformation).length > 0 ? (
                        <Grid2 className="su-homepage__right" md={4}>
                            {userInformation &&
                            userInformation.role == ROLES.SU ? (
                                <DefaultWidget />
                            ) : null}
                            {userInformation &&
                            userInformation.role == ROLES.PU ? (
                                <DefaultPUWidget />
                            ) : null}
                        </Grid2>
                    ) : null}
                </Grid2>
            ) : null}

            {/* Display content out of GRID component for theme black */}
            {isThemeblk() ? (
                <React.Fragment>
                    <ProfileContainer
                        user={user}
                        coverPic={coverPic}
                        getUserInformation={getUserInformation}
                        subcovers={subcovers}
                    />

                    <div
                        className={`container profile__bio-container pb-4 ${
                            isThemeblk()
                                ? "themeblk-profile__bio-container"
                                : ""
                        }`}
                    >
                        {[
                            FOLLOW_STATUS.ACTIVE,
                            FOLLOW_STATUS.UNFOLLOWED_DOES_NOT_RENEW,
                            FOLLOW_STATUS.PAUSED,
                        ].includes(user.subscription_status) && (
                            <div
                                className={`container post-media-tabbed-container mt-5`}
                            >
                                <StyledTabs
                                    value={key}
                                    onChange={handleChangeTab}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    variant="fullWidth"
                                    aria-label="full width profile tabs"
                                    nutTheme={isThemeblk()}
                                >
                                    <StyledTab
                                        className="profile-tab"
                                        label={
                                            <i className="fa-regular fa-photo-film"></i>
                                        }
                                        {...tabProps(0)}
                                        nutTheme={isThemeblk()}
                                    />
                                    <StyledTab
                                        className="profile-tab"
                                        label={
                                            <i className="fa-sharp fa-solid fa-grid"></i>
                                        }
                                        {...tabProps(1)}
                                        nutTheme={isThemeblk()}
                                    />
                                    <StyledTab
                                        className="profile-tab"
                                        label={
                                            <Badge
                                                anchorOrigin={{
                                                    vertical: "top",
                                                    horizontal: "right",
                                                }}
                                                sx={{
                                                    "& .MuiBadge-badge": {
                                                        backgroundColor:
                                                            "transparent",
                                                        color: isThemeblk()
                                                            ? "#ffd700"
                                                            : "#0097fe",
                                                        fontWeight: "bold",
                                                        right: "-16px",
                                                    },
                                                }}
                                                badgeContent="NEW"
                                            >
                                                <i className="fa-regular fa-cart-shopping"></i>
                                            </Badge>
                                        }
                                        {...tabProps(2)}
                                        nutTheme={isThemeblk()}
                                    />
                                </StyledTabs>
                                <div id="pu-content-container">
                                    <TabPanel value={key} index={0}>
                                        <PostsContent user={user} />
                                    </TabPanel>
                                    <TabPanel value={key} index={1}>
                                        <MediaContents user={user} />
                                    </TabPanel>
                                    <TabPanel value={key} index={2}>
                                        <ShopContents user={user} />
                                    </TabPanel>
                                </div>
                            </div>
                        )}

                        {((!userInformation && user.role == ROLES.PU) ||
                            ([ROLES.PU, ROLES.ADMIN].includes(
                                parseInt(user.role)
                            ) &&
                                [FOLLOW_STATUS.UNSUBSCRIBED, false].includes(
                                    user.subscription_status
                                ))) && (
                            <div className="post-box post-box-follow banned-content-container">
                                <div className="user-info clearfix">
                                    <div className="info-lft pull-left">
                                        <div className="usr-img img-div">
                                            <Avatar pu={user} story={false} />
                                        </div>
                                        <div className="user-name">
                                            <p>
                                                <strong>
                                                    {user.firstname}{" "}
                                                    {user.lastname}
                                                </strong>{" "}
                                                <span>
                                                    <a
                                                        href={`${window.location.origin}/${user.login}`}
                                                    >
                                                        @{user.login}
                                                    </a>
                                                </span>
                                            </p>
                                            <div className="mobile-time">
                                                {post.created_at
                                                    ? moment
                                                          .utc(post.created_at)
                                                          .local()
                                                          .format("lll")
                                                    : ""}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={` ${setThemeBottomBanner()}`}>
                                    <div className="follow-prv-host-one ajaxconttest">
                                        {showButterflyLock() ? (
                                            <div className={"butterfly-locked"}>
                                                {" "}
                                                <LazyLoadImage
                                                    src={ButterflyLock}
                                                    alt="ban-logo"
                                                />{" "}
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                        <h3>
                                            <span>
                                                Follow to see all my private
                                                posts
                                            </span>
                                        </h3>

                                        {![1, 30167].includes(user.id) && (
                                            <a
                                                onClick={() => setShow(true)}
                                                className={`btn btn-follow-2 btn-default ${setFollowBottonOnBanner()}  ${
                                                    isProcessing ||
                                                    processingIntent
                                                        ? " disable-link disabled"
                                                        : ""
                                                }`}
                                            >
                                                {isProcessing ||
                                                processingIntent
                                                    ? "PROCESSING..."
                                                    : "FOLLOW"}
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </React.Fragment>
            ) : null}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        isProcessing: state.follow.isProcessing,
        subcovers: state.user.subcovers,
        isDarkmode: state.privaGlobal.darkmode,
    };
};

export default React.memo(connect(mapStateToProps)(ProfileView));
